import React from 'react';

import * as style from './style.module.css';

const Switch = ({ register = {}, readOnly = false, className = '', required = false, ...props }) => {
  return (
    <label className={`${style.swtch} ${readOnly ? style.readOnly : ''} ${className}`}>
      <input type="checkbox" required={required} {...register} {...props} disabled={readOnly} />
      <span className={style.slider}></span>
    </label>
  );
};

export default React.memo(Switch);
